import { CommonModule } from '@angular/common';
import { Component, HostListener, Input, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Claim } from 'src/app/models/claim';
import { TimeoutService } from 'src/app/services/timeout.service';

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.css'],
  standalone: true,
  imports: [CommonModule,
    TranslateModule
  ]
})

/* This class is responsible for Display confirmation message and redirect link of print a copy of your submission */
export class ConfirmationComponent implements OnInit {

  public claimId: number;
  @Input('currentLocale') set updateCurrentLocale(locale: string){
    localStorage.setItem('currentLang' , locale);
  }

  constructor(
    private timeout: TimeoutService
  ) {
    this.timeout.stop();
    this.timeout.init(true);
  }

  ngOnInit() {
    this.getClaimId();
    this.clearSession();
    window.scroll({top:0, left:0, behavior:'smooth'});
  }

  @HostListener('window:beforeunload', [ '$event' ])
  beforeUnloadHandler(event) {
    localStorage.removeItem('claimPrint');
    localStorage.removeItem('claimDocumentsList');
    localStorage.removeItem('audiogramDocumentsList');
    localStorage.removeItem('audiogramDocumentsList');
    localStorage.removeItem('currentLang');
}
  getClaimId = (): number => {

    if (sessionStorage.getItem('claim')) {
      const claim: Claim = JSON.parse(sessionStorage.getItem('claim'));
      const date = new Date(sessionStorage.getItem('submitionDate'));
      claim.submitionDate = date;
      // sessionStorage.setItem('claimPrint', JSON.stringify(claim));
      localStorage.setItem('claimPrint', JSON.stringify(claim));
      return this.claimId = claim.claimId;
    }

  }

  clearSession = () => {
    sessionStorage.removeItem('claimId');
    sessionStorage.removeItem('referenceNumber');
    sessionStorage.removeItem('claim');
    sessionStorage.removeItem('dateOfBirth');
    sessionStorage.removeItem('submitionDate');
    // sessionStorage.removeItem('claimDocumentsList');
    // sessionStorage.removeItem('audiogramDocumentsList');
  }

}
